<template>
  <div :class="['content-col', colSize, alignSelfComp, colOffset]">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'content-col',
  props: {
    size: {
      type: String,
      default: '12'
    },
    alignSelf: {
      type: String,
      default: 'center'
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    colSize() {
      return `col-lg-${this.size}`
    },
    alignSelfComp() {
      return `align-self-${this.alignSelf}`
    },
    colOffset() {
      return `offset-lg-${this.offset}`
    }
  }
}
</script>